import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import TasksContext from "../context/tasks-content";
import firstImage from "../Resourses/img/2.png";


const TaskDetailesPage = ()=>{
  let params = useParams();
  let taskContext = useContext(TasksContext);

  let [taskDetailes ,setTaskDetailes] =useState({});
  // let taskDetailes ={};
  let fetchTasksDetailes =()=>{
    let filteredTasks = taskContext.tasks.filter(
      (element)=>element.id == params.id
      );
    setTaskDetailes(filteredTasks[0]);
  };

  let statusChangeHandler =(status)=>{
    const token = taskContext.token;
    // setTaskDetailes((prvTask)=>{
    //   prvTask.status =status;
    //   return { ...prvTask};
    // });

    axios
    .patch(`https://vp-react-tasks-642b9-default-rtdb.firebaseio.com/tasks/${taskDetailes.id}.json?auth=${token}`,
    {
      status:status,
    } 
    ).then((response)=>{
      setTaskDetailes((prvTask)=>{
        prvTask.status =status;
        return { ...prvTask}
      });
      console.log(taskDetailes);
    }
    ).catch((error)=>{
      console.log(error);
    });
  
    
  };
  useEffect(fetchTasksDetailes,[]);

  // let upDateChangeHandler =(status)=>{
  //   const token = taskContext.token;

  //    axios
  //   .patch(`https://vp-react-tasks-642b9-default-rtdb.firebaseio.com/tasks${taskDetailes.id}.json?auth${token}`,
  //   {
  //     status :status,
  //   })
  //   .then((response)=>{
  //     setTaskDetailes((prvTask)=>{
  //       prvTask.status =status;
  //       return { ...prvTask};
  //     });
  //   })
  //   .catch((error)=>{});
  // };

return (
  
  <main  className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1  className="h2">Tasks Details ({taskDetailes.title})</h1>
    <div  className=" mb-2 mb-md-0">
    <div  className="d-flex align-items-center ms-3 ms-lg-4"></div>
    <div  className="d-flex align-items-center ms-3 ms-lg-4"></div>
    </div>


    <div  className="btn-toolbar mb-2 mb-md-0">
      <div  className="btn-group me-2">     	 
      <button 
      onClick={()=> statusChangeHandler("In Progress")}
      type="button"  
      className={`btn btn-sm btn-outline-secondary ${
        taskDetailes.status == "In Progress" ? "active":"" 
      }`}
        >
      In Progress
      </button>
      <button 
       onClick={()=> statusChangeHandler("Complete")}
      type="button" 
      className={`btn btn-sm btn-outline-secondary ${
        taskDetailes.status == "Complete" ? "active":"" 
      }`}
        >
      Complete
      </button>
      <button 
      onClick={()=> statusChangeHandler("Waiting")}
      type="button"  
      className={`btn btn-sm btn-outline-secondary ${
        taskDetailes.status == "Waiting" ? "active":"" 
      }`}
        >
      Waiting
      </button>
      <button 
      onClick={()=> statusChangeHandler("Canceled")}
      type="button" 
      className={`btn btn-sm btn-outline-secondary ${
        taskDetailes.status == "Canceled" ? "active":"" 
      }`}
      >
      Canceled
      </button>
      </div>
      <button 
      // onClick={upDateChangeHandler}
      type="button"  
      className="btn btn-light-main btn">
      
      <span data-feather="edit-3"></span> 
      Edit
      </button>
    </div>
    </div>

    <div  className="row mt-5"> 
        <div  className="col-md-6">
        <img src={firstImage}   className="img-fluid rounded de-img" />
        </div>
        <div  className="col-md-6  mt-5">
        <div  className=" mb-3">
          <span data-feather="bookmark" 
          className="main-color"></span>
            <strong>Title:</strong> {taskDetailes.title}
        </div>
          <div  className="mb-3">
          <span data-feather="layers"  
          className="main-color"></span> 
          <strong>Category:</strong> {taskDetailes.category}
        </div>
        <div  className="">
          <span data-feather="calendar" 
          className="main-color"></span> 
          <strong>Date:</strong> {taskDetailes.startDate} to {taskDetailes.endDate}
        </div>
          </div>
        <div  className="row mt-5">
          <div  className="task-info">     
            {taskDetailes.details}
          </div>
        </div>
    </div> 
  </main>
   
    )
}
export default TaskDetailesPage;